import { mediumBreakpoint } from './constants';

export const getIsMobile = () => window.innerWidth <= mediumBreakpoint;
